import { LoteDsItemComponent } from 'src/app/shared/lote-ds-item/lote-ds-item.component';
import { CardSdcItemComponent } from './../shared/card-sdc-despalha/partialViews/sdc-card-item.component';
import { NotificationService } from './../services/notification.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardHeaderComponent } from '../shared/card-header/card-header.component';
import { AngularmaterialModule } from './angular-material-module';
import { GeneralService } from '../services/general.service';
import { FilterDetailComponent } from '../shared/filter-detail/filter-detail.component';
import { CardLoadingComponent } from '../shared/card-loading/card-loading.component';
import { OnlyNumberDirective } from '../directives/only-number.directive';
import { OnlyNumberVirgulaDirective } from '../directives/only-number-virgula.directive';
import { CardBarCodeComponent } from '../shared/card-barcode/card-barcode.component';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { CardSdcComponent } from '../shared/card-sdc-despalha/sdc-card.component';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG, CurrencyMaskModule } from 'ng2-currency-mask';
import { CardSnackBarComponent } from '../shared/card-snackbar/card-snackbar.component';
import { SimpleModalComponent } from '../shared/simple-modal/simple-modal.component';
import { FormModalConfirmComponent } from '../shared/form-modal-confirm/form-modal-confirm.component';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
import { Qua007PesagemItemComponent } from '../shared/qua007-pesagem-item/qua007-pesagem-item.component';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { Sec002SecagemItemComponent } from '../shared/sec002-secagem-item/sec002-secagem-item.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'left',
    allowNegative: false,
    decimal: ',',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: '.'
};

@NgModule({
    declarations: [
        CardHeaderComponent,
        FilterDetailComponent,
        CardLoadingComponent,
        OnlyNumberDirective,
        OnlyNumberVirgulaDirective,
        CardBarCodeComponent,
        CardSdcComponent,
        CardSdcItemComponent,
        CardSnackBarComponent,
        SimpleModalComponent,
        LoteDsItemComponent,
        FormModalConfirmComponent,
        Sec002SecagemItemComponent,
        Qua007PesagemItemComponent,
    ],
    imports: [
        AngularmaterialModule,
        CommonModule,
        CurrencyMaskModule,
        NgxMaskModule.forRoot(options),
    ],
    exports: [
        CardHeaderComponent,
        FilterDetailComponent,
        CardLoadingComponent,
        OnlyNumberDirective,
        OnlyNumberVirgulaDirective,
        CardBarCodeComponent,
        CardSdcComponent,
        CardSdcItemComponent,
        CardSnackBarComponent,

    ],
    entryComponents: [
        CardBarCodeComponent
    ],
    providers: [
        GeneralService,
        NotificationService,
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true, disableClose: true } },
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
    ],
    bootstrap: []
})
export class SharedModule { }
